﻿import {Component, Input, Output, EventEmitter, ViewContainerRef} from '@angular/core';
import {TextBoxBase} from '../textBox/textBoxBase';

@Component({
    selector: 'jax-htextbox',
    inputs: ['label', 'isDisabled', 'type', 'inputValue', 'isMandatory', 'propertyName', 'propertyDisplayName', 'validate', 'validators', 'maxLength', 'isReadOnly', 'autocomplete'],
    templateUrl: './horizontaltextBox.component.html'
})
export class HorizontalTextBoxComponent extends TextBoxBase {

    label: string;
    autocomplete = 'on';

    @Output() inputValueChange: any = new EventEmitter();

    private inputLabel: string;


    constructor(elemRef: ViewContainerRef) {
        super(elemRef);
    }

    updateValue(event) {
        this.inputValue = event;
        this.inputValueChange.emit(event);
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.dispose();
    }
}
